import React, { Component } from 'react';
import Organization from '../../../organization/Item'
import CongregationsList from '../../../congregations/List'
import CommunityList from '../../../community/List'
import SelectCongregation from '../../../congregations/SelectCongregation'
import SelectCommunity from '../../../community/SelectCommunity'
import Item from '../../../organization/Item'

class SelectOrganization extends Component {
    render() {
        if(this.props.organization.type==="community") {
            let items = [];
            if(this.props.attachedCongregations.length > 0) {
                this.props.attachedCongregations.forEach(function(congregation, index) {
                    items.push(<SelectedItem
                        information={congregation}
                        onHandleRegretAttachingCongregation={this.props.onHandleRegretAttachingCongregation}
                        key={index} />)
                }.bind(this));
            }
            return(
			    <div>
                    <h2 id="menigheder">Menigheder</h2>
                    {this.props.user.type === "admin" && <SelectCongregation onHandleAttachCongregation={this.props.onHandleAttachCongregation} /> }
                    {this.props.attachedCongregations.length > 0 &&
                        <div>
                        <h3 style={{margin: '2em 0 0 0'}}>Nye tilknyttede menigheder</h3>
                        <div style={{fontStyle: 'oblique'}}>(Bemærk at de først bliver tilknyttet ved tryk på "Gem og luk")</div>
                            {items}
                        </div>
                    }
                    {this.props.organization.children && <RelatedCongregations congregations={this.props.organization.children} onHandleDetachCongregation={this.props.onHandleDetachCongregation} user={this.props.user} />}
                </div>
      	    );
        } else {
            return(
                <div>
                    <h2>Trossamfund</h2>
                    {this.props.user.type === "admin" && <SelectCommunity onHandleAttachCommunity={this.props.onHandleAttachCommunity} /> }
                    {this.props.attachedCommunity &&
                        <div style={{position: 'relative'}}>
                            <h3 style={{margin: '1em 0 0 0'}}>Nyt tilknyttet trossamfund (overskriver eksisterende når der gemmes)</h3>
                            <div style={{position: 'relative', display: 'flex'}}>
                                <Item information={this.props.attachedCommunity} hideEditLink={true} />
                                <div style={{display: 'flex', margin: '0 1em', alignItems:'center'}}>
                                    <img
                                        src="/images/assets/kryds.svg"
                                        alt="Fjern tilknytning"
                                        height="26"
                                        width="26"
                                        style={{cursor: 'pointer'}}
                                        onClick={() => this.props.onHandleRegretAttachingCommunity()}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {!Array.isArray(this.props.organization.parent) && this.props.organization.id>0 && <RelatedCommunity organization={this.props.organization} onHandleDissociateComunity={this.props.onHandleDissociateComunity} user={this.props.user} />}
                </div>
            );
        }
	}
}

const SelectedItem = (props) => (
    <div style={{position: 'relative', display: 'flex'}}>
        <Item information={props.information} hideEditLink={true} />
        <div style={{display: 'flex', margin: '0 1em', alignItems:'center'}}>
            <img
                src="/images/assets/kryds.svg"
                alt="Fjern tilknytning"
                height="26"
                width="26"
                style={{cursor: 'pointer'}}
                onClick={() => props.onHandleRegretAttachingCongregation(props.information.id)}
            />
        </div>
    </div>
)

const RelatedCommunity = (props) => (
    <div>
        <h3 style={{margin: '2em 0 0 0'}}>Tilknyttet trossamfund</h3>
        <CommunityList information={props.organization.parent} onHandleDissociateComunity={props.onHandleDissociateComunity} user={props.user} />
    </div>
);

const RelatedCongregations = (props) => (
    <div>
        <h4 style={{margin: '2em 0 0 0'}}>Anerkendte menigheder tilknyttet trossamfundet.</h4>
        <CongregationsList congregations={props.congregations} onHandleDetachCongregation={props.onHandleDetachCongregation} user={props.user} />
    </div>
);

export default SelectOrganization;



// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/SelectOrganization.js